<template>
    <el-dialog
      title="查看ACG子集"
      :append-to-body="true"
      :visible.sync="acgDialog"
      width="70%"
      @close="closeDialog"
    > 
      <div class="header" v-if="showSearch">
        <Tabs
          @searchData="editForm"
          :fileType="fileTypeList"
          :size="'dialog'"
          @resetData="editForm"
        ></Tabs>
      <el-button size="small" type="success" @click="showDialog1"
        >子集批量审核</el-button
      >
      <el-button size="small" type="success" @click="deleteTable(false)"
        >子集批量删除</el-button
      >
      </div>
      <el-table
        :data="tableSm"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange1"

      >
        <el-table-column type="selection" width="55" v-if="showSelection"> </el-table-column>
        <el-table-column
          prop="id"
          label="ID"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="episode_number"
          label="第几集"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="title"
          label="章节名"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="media_type"
          label="播放"
          width="200"
          align="center"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <el-button
              v-if="
                scope.row.media_type == 1 ||
                scope.row.media_type == 5 ||
                scope.row.media_type == 6
              "
              @click="lookVideoDialogFun(scope.row)"
              size="mini"
              >播放动画</el-button
            >
            <decrypt-img
              v-if="scope.row.urls && scope.row.media_type == 2"
              style="width: 100px; height: 100px"
              :src="handleImageUrl(scope.row.urls.split(',')[0])"
              fit="cover"
            ></decrypt-img>
            <div v-if="scope.row.media_type == 3">
              <el-button @click="setText(scope.row.text)" size="mini"
                >查看内容</el-button
              >
            </div>
            <div v-if="scope.row.media_type == 4 && scope.row.audio_url">
              <audio controls crossorigin="anonymous">
                <source
                  :src="handleImageUrl(scope.row.audio_url)"
                  type="audio/mpeg"
                />
              </audio>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="media_type"
          label="媒体类型"
          align="center"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.media_type == 1">动画</span>
            <span v-else-if="scope.row.media_type == 2">漫画</span>
            <span v-else-if="scope.row.media_type == 3">文本小说</span>
            <span v-else-if="scope.row.media_type == 4">有声小说</span>
            <span v-else-if="scope.row.media_type == 5">短剧</span>
            <span v-else-if="scope.row.media_type == 6">有声漫</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="fs_resource_status"
          label="文件状态"
          align="center"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            {{ scope.row.fs_resource_status }}
          </template>
        </el-table-column>
        <el-table-column
          prop="status"
          label="状态"
          align="center"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <el-tag style="margin: 5px 0" :type="getStatusTagType(scope.row.status)">
              <span v-if="scope.row.status == 1">审核通过</span>
              <span v-else-if="scope.row.status == 2">拒绝</span>
              <span v-else-if="scope.row.status == 3">下架</span>
              <span v-else>审核中</span>
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="sale_coin"
          label="价格"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="cover"
          label="封面"
          align="center"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <img-load
              v-if="scope.row.cover"
              :key="scope.row.cover"
              :src="handleImageUrl(scope.row.cover)"
            ></img-load>
            <span v-else>无</span>
          </template></el-table-column
        >
        <el-table-column
          prop="play_time"
          label="影片长度"
          align="center"
        ></el-table-column>
        <el-table-column prop="urls" label="地址集" align="center">
          <template slot-scope="scope">
            <!-- {{ scope.row.urls.split(",")[0] }} -->
            <div
              @click="
                previewPicture(
                  scope.row.urls.split(','),
                  scope.row.id,
                  scope.row.tags
                )
              "
            >
              <decrypt-img
                :iPreviewSrcList="[]"
                v-if="scope.row.urls"
                style="width: 100px; height: 100px"
                :src="handleImageUrl(scope.row.urls.split(',')[0])"
              ></decrypt-img>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="media_size"
          label="资源大小"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="width"
          label="宽"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="height"
          label="高"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="ratio"
          label="宽高比"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="reason"
          label="拒绝理由"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="edit_by"
          label="编辑者"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <!-- 
                <el-table-column prop="audio_url" label="有声小说地址" align="center" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="review_by" label="编辑相关" align="center" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="text" label="内容" align="center" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="video_id" label="媒体资源ID" align="center" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="is_delete" label="是否删除" align="center" :show-overflow-tooltip="true"> 
                 <template slot-scope="scope">
                    <span v-if="scope.row.is_delete == 1">已删除</span>
                    <span v-else>未删除</span>
                </template>
              </el-table-column> 
       -->
      </el-table>
      <!-- 分页组件 -->
      <div class="bottom">
        <div class="page">
          <el-pagination
            :page-sizes="[10, 25, 50, 100]"
            :current-page="dialogPage.page"
            :page-size="dialogPage.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="dialogPage.total"
            background
            v-if="dialogPage.total > 10"
            @size-change="changeSize1"
            @current-change="changeCurrent1"
          ></el-pagination>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="closeDialog">确 定</el-button>
      </span>
    </el-dialog>
</template>

<script>
import API from '@/api/acg'
import decryptImg from '@/components/decrypt-img'
import imgLoad from '@/components/imgLoad'
import Tabs from './tabs.vue'

export default {
  name: 'acgSubList',
  components: {
    decryptImg,
    imgLoad,
    Tabs
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    mediaId: {
      type: [String, Number],
      default: null
    },
    showSearch: {
      type: Boolean,
      default: false
    },
    showSelection: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      acgDialog: false,
      loading: false,
      tableSm: [],
      dialogPage: {
        page: 1,
        size: 10,
        total: 0,
        media_id: null
      },
      fileTypeList: [
        { value: 0, label: '未处理' },
        { value: 1, label: '处理中' },
        { value: 2, label: '处理完成' },
        { value: 3, label: '处理失败' }
      ],
    }
  },
  watch: {
    visible: {
      handler(newVal) {
        this.acgDialog = newVal
        if (newVal && this.mediaId) {
          this.loadSubListData()
        }
      },
      immediate: true
    },
    mediaId: {
      handler(newVal) {
        if (newVal && this.acgDialog) {
          this.dialogPage.media_id = newVal
          this.loadSubListData()
        }
      },
      immediate: true
    }
  },
  methods: {
    // 加载子集数据
    loadSubListData() {
      if (!this.mediaId) return
      
      const params = {
        ...this.dialogPage,
        media_id: this.mediaId,
      }
      
      API.getAcgDetailData(params).then((res) => {
        if (res.code === 0) {
          this.tableSm = res.data.data || []
          this.dialogPage.total = res.data.pagination.count
        } else {
          this.$message.error(res.message || '获取子集数据失败')
        }
      }).catch((error) => {
        console.error('获取子集数据失败:', error)
        this.$message.error('获取子集数据失败')
      })
    },
    
    // 处理图片URL
    handleImageUrl(val) {
      if (val.indexOf("http") === 0) {
        val = "/" + val.split("/").slice(3).join("/");
      } else if (val.indexOf("/") !== 0) {
        val = "/" + val;
      }
      // 根据去掉域名后的数据进行匹配
      let strValue = "";
      let data = JSON.parse(JSON.parse(localStorage.getItem("imageUrl")));
      for (const key in data) {
        if (key.indexOf("/") !== 0 && key !== "*") {
          //如果匹配键名前面不带'/'
          if (val.indexOf("/" + key + "/") === 0) {
            //
            strValue = data[key];
          }
        } else if (key.indexOf("/") === 0 && key !== "*") {
          //带'/'
          if (val.indexOf(key + "/") === 0) {
            //有匹配的
            strValue = data[key];
          }
        }
      }
      if (strValue) {
        return strValue + val;
      } else {
        return data["*"] + val;
      }
    },
    
    // 查看视频对话框
    lookVideoDialogFun(data) {
      this.$emit('lookVideo', data)
    },
    
    // 设置文本内容
    setText(text) {
      this.$emit('setText', text)
    },
    
    // 预览图片
    previewPicture(urls, id, tags) {
      this.$emit('previewPicture', urls, id, tags)
    },
    
    // 分页大小改变
    changeSize1(size) {
      this.dialogPage.size = size
      this.dialogPage.page = 1
      this.loadSubListData()
    },
    
    // 分页页码改变
    changeCurrent1(page) {
      this.dialogPage.page = page
      this.loadSubListData()
    },
    
    // 关闭弹窗
    closeDialog() {
      this.acgDialog = false
      this.$emit('update:visible', false)
    },
    getStatusTagType(status) {
      if (status == 1) return 'success'
      if (status == 2) return 'danger'
      if (status == 3) return 'info'
      return 'warning'
    },
    showDialog1() {
      this.$emit('showDialog1')
    },
    deleteTable(isDelete) {
      this.$emit('deleteTable', isDelete)
    },
    editForm(obj) {
      console.log(obj, "RISE");
      // if (obj.id && !obj.inFrom) {
      //   this.dialogPage.media_id = obj.id;
      // }
      const currentSize = this.dialogPage.size || 10
      if (obj.inFrom) {
        // 搜索时保留当前每页条数
        this.dialogPage = { ...obj, media_id: this.mediaId, page: 1, size: currentSize };
      }
      if (obj.reset) {
        // 有传 size（筛选项重置）用传入值；批量审核只传 { reset: true } 时保留当前 size
        this.dialogPage = {
          ...obj,
          media_id: this.mediaId,
          page: 1,
          size: obj.size != null ? obj.size : currentSize,
        };
      }
      // inFrom / reset 是前端控制标记，不能带到接口参数里
      delete this.dialogPage.media_type;
      delete this.dialogPage.inFrom;
      delete this.dialogPage.reset;
      this.loadSubListData()
    },
    handleSelectionChange1(selection) {
      this.$emit('selectionChange', selection)
    }
  }
}
</script>

<style scoped>
.bottom {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

.page {
  text-align: center;
}

.dialog-footer {
  text-align: right;
}
</style>